export enum ImportType {
  Bookings = 'bookings',
  CustomerBehaviors = 'customer behaviors',
  Customers = 'customers',
  ExcludedAccounts = 'excluded accounts',
  ExcludedProducts = 'excluded products',
  LinkedAccounts = 'linked accounts',
  Locations = 'locations',
  Orders = 'orders',
  Products = 'products',
  Salespersons = 'salespersons',
  ScheduledNotifications = 'scheduled notifications',
  TierOverrides = 'tier overrides',
  UpdatePoints = 'update points',
}
